module.exports = __webpack_public_path__ + "static/problem-statement-891bd7dbc7b5e3b6d129838657805875.png";